function homeToggleSummer(withAnimation = true) {
    if (withAnimation) {
        $('#app').fadeOut(500, function () {
                restartPlayer('.summer-content.video-container iframe');
                toggleBodySeason('estate');
                $('.winter-content').hide();
                $('.summer-content').show();
                $('#app').fadeIn(500);

            }
        );
    } else {
        toggleBodySeason('estate');
    }
    $('.go-to-seasons').attr('href', summerUrl);
}

function homeToggleWinter(withAnimation = true) {
    if (withAnimation) {
        $('#app').fadeOut(500, function () {
                restartPlayer('.winter-content.video-container iframe');
                toggleBodySeason('inverno');
                $('.winter-content').show();
                $('.summer-content').hide();
                $('#app').fadeIn(500);

            }
        );
    } else {
        toggleBodySeason('inverno');
    }
    $('.go-to-seasons').attr('href', winterUrl);
}

function toggleBodySeason(season) {
    let $body = $('body');

    if (season === 'inverno') {
        $body.removeClass('estate').addClass('inverno');
    } else if (season === 'estate') {
        $body.removeClass('inverno').addClass('estate');
    }
}

function restartPlayer(selector) {
    var iframes = document.querySelectorAll(selector);
    for (iframe of iframes) {

        // resetto src in quanto gtm la ranza in qualche modo, se vimeo non ha src da errore
        iframe.src = iframe.getAttribute('data-src');

        var player = new Vimeo.Player(iframe);
        player.setCurrentTime(0).then(function (selector) {
            player.play();
        }).catch(function (error) {
            console.log('Vimeo error', error)
        });
    }
}


function initFrontPage() {
    let hash = window.location.hash;

    hash = hash.replace('#', '');

    if (hash === '') {
        return;
    }

    if (hash === 'estate') {
        homeToggleSummer(false);
    } else {
        homeToggleWinter(false);
    }

    console.log(hash);
}

/** FUNZIONE PER MOSTRARE O NASCONDERE LE OFFERTE LUNGHE O CORTE */
function toggleSelectedDuration(selectedDuration) {
    if (selectedDuration === 'short') {
        $('.offer-list-item[data-offer-duration="long"]').parent().hide();
        $('.offer-list-item[data-offer-duration="short"]').parent().fadeIn('slow');
    } else if (selectedDuration === 'long') {
        $('.offer-list-item[data-offer-duration="short"]').parent().hide();
        $('.offer-list-item[data-offer-duration="long"]').parent().fadeIn('slow');
    } else if (selectedDuration === 'all') {
        $('.offer-list-item-container').fadeIn('slow');
    } else {
        console.log('invalid duration');
    }
}

/** FUNZIONE PER CAMBIARE LE IMMAGINI IN HOME ALL'HOVER DEL "MENU" LATERALE */
function changeImgOnHover($clicked) {
    $('.btn-for-roll').removeClass('selected-option');
    $clicked.addClass('selected-option');
    var isSummer = $('body').hasClass('estate');
    var winterImg = $clicked.data('winter-img');
    var summerImg = $clicked.data('summer-img');
    $('.home-top-img.winter-content').attr('src', winterImg);
    $('.home-top-img.summer-content').attr('src', summerImg);
}

$(() => {

    initFrontPage();

    $('.season-winter').on('click', function () {
        if ($('body').hasClass('estate')) {
            homeToggleWinter();
        }
    });

    $('.season-summer').on('click', function () {
        if (!$('body').hasClass('estate')) {
            homeToggleSummer();
        }
    });

    /** season archive switcher between long and short or both */
    $('.offer-duration-chooser').on('click', function () {
        var $clicked = $(this);
        $('.offer-duration-chooser').removeClass('offer-duration-selected');
        $clicked.addClass('offer-duration-selected');
        var durationSelected = $clicked.data('duration');
        toggleSelectedDuration(durationSelected);
    });

    $('.offer-slider-chooser').on('click', function () {
        var $clicked = $(this);
        if (!$clicked.hasClass('offer-duration-selected')) {
            $('.offer-slider-chooser').removeClass('offer-duration-selected');
            $clicked.addClass('offer-duration-selected');
            var sliderToShow = $clicked.data('slider-container');
            $('.offer-slider').hide();
            $('.' + sliderToShow).fadeIn('slow');
        }
    });
    $('.offer-duration-short-container').hide();

    // cambio immage in home (estate e inverno) quando si passa sopra alle voci di menu a fianco
    var $btnForRoll = $('.btn-for-roll');
    $btnForRoll.on('mouseenter', function () {
        $clicked = $(this);

        var isSummer = $('body').hasClass('estate');
        var winterImg = $clicked.data('winter-img');
        var summerImg = $clicked.data('summer-img');

        $('.video-container.summer-content').css('background-image', 'url("' + summerImg + '")');
        $('.video-container.winter-content').css('background-image', 'url("' + winterImg + '")');

        var $videoCont = $('.video-container iframe');
        $videoCont.stop().fadeTo("fast", 0);
    });

    $btnForRoll.on('mouseleave', function () {
        var $videoCont = $('.video-container iframe');
        $videoCont.stop().fadeTo("fast", 1);
    });

    /*
      OLD funzionante quando in home non c'erano i video
      $btnForRoll.on('mouseover', function () {
      var $clicked = $(this);
      changeImgOnHover($clicked);
    });*/
    $btnForRoll.on('mouseout', function () {
        $('.home-top-img').attr('src', function () {
            return $(this).data('default-img');
        });
        $('.btn-for-roll').removeClass('selected-option');
    });

    //lightbox-galleria
    /*$('.gallery-single-img').on('click', function () {
      var $clicked = $(this);
      var clickedSrc = $clicked.attr('src');
      $('#gallery-modal img').attr('src', clickedSrc);
      $('#gallery-modal').modal('show');
    });*/

    //pulsante quotation
    $(window).scroll(function () {
        var scrollPos = document.documentElement.scrollTop;
        if (scrollPos > 100) {
            $('.home .btn-quotation').css('right', 0);
        } else {
            $('.home .btn-quotation').css('right', '-220px');
        }
    });

    /*$('body').on('click', '.nf-add-fieldset', function() {
      setTimeout( function () {
        $('.kid-number-selector select').trigger('change');
      }, 500);
    });
    $('body').on('click', '.nf-remove-fieldset', function() {
      setTimeout( function () {
        $('.kid-number-selector select').trigger('change');
      }, 500);
    });*/

    $('body').on('change', '.kid-number-selector select', function () {

        var $changed = $(this);
        var numSelected = $changed.val();
        var $roomContainer = $changed.closest('nf-fields-wrap');
        var possibleInputContainers = [6, 5, 4, 3, 2, 1];

        possibleInputContainers.forEach(function (item, index, array) {
            var currentItem = $roomContainer.find('.kid-year-container-' + item);
            if (parseInt(item) > numSelected) {
                currentItem.hide(100);
            } else {
                currentItem.show(100);
            }

        });
    });
});

//listen to keyboard arrow presses and press left or right navigation in gallery lightbox
$(document).on('keydown', function (event) {
    if ($('.modal.lightbox').hasClass('show')) {
        event.preventDefault();
        switch (event.keyCode) {
            case 37: //press left arrow on keyboard
                $('.carousel-control.carousel-control-prev').click();
                break;
            case 39: //press right arrow on keyboard
                $('.carousel-control.carousel-control-next').click();
                break;
        }
    }
});

/*
 * SIMPLE BOOKING
 */
var today = new Date().toLocaleDateString('en-US');
var genzia_accent = '#565B53';
var genzia_light = '#F5F0EC';
$(document).ready(function () {
    (function (i, s, o, g, r, a, m) {
        i['SBSyncroBoxParam'] = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
            m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'https://cdn.simplebooking.it/search-box-script.axd?IDA=2779', 'SBSyncroBox');
    SBSyncroBox({
        CodLang: getLangCode.toUpperCase(),
        Checkin: today,
        Styles: {
            Theme: "default",
            CustomColor: genzia_light,   //primary color ex. #CDEFDD
            CustomBGColor: genzia_accent,   //background color
            CustomLabelColor: genzia_light,   //labels color
            CustomWidgetColor: genzia_light,   //popovers text color
            CustomButtonColor: genzia_light,
            CustomButtonBGColor: genzia_accent,
            CustomButtonHoverBGColor: genzia_accent
        },
    });
});

function openSb() {
    $('.simple-booking-slider-container').css('bottom', 0);
    jQuery('.navbar .navbar-toggler.active').click();
}

function closeSb() {
    $('.simple-booking-slider-container').css('bottom', '-400px');
}

//$('.open-sb-form').click(openSb);
$('body').on('click', 'button.open-sb-form, .open-sb-form a', function (e) {
    e.preventDefault();
    console.log('click prenota ora');
    openSb();
});

$('.close-sb-form').click(closeSb);


// SIMPLE BOOKING
//reservationContainer.append('<a href="#" class="close-reservation-collapsible" data-bs-toggle="collapse" data-bs-target="#reservation-container" aria-expanded="true" aria-controls="multiCollapseExample2">Chiudi</a>');
/*var myCollapsible = document.getElementById('reservation-container')
myCollapsible.addEventListener('shown.bs.collapse', function () {
  var reservationContainer = document.getElementById('sb-container');

  if (reservationContainer.innerHTML === '') {
    (function (i, s, o, g, r, a, m) {
      i['SBSyncroBoxParam'] = r;
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments)
      }, i[r].l = 1 * new Date();
      a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'https://cdn.simplebooking.it/search-box-script.axd?IDA=2779', 'SBSyncroBox');
    SBSyncroBox({
      CodLang: getLangCode.toUpperCase(),
      Checkin: '12/03/2021',
      Styles: {
        Theme: "light-pink",
        CustomColor: "#51443e",   //primary color ex. #CDEFDD
        CustomBGColor: "#ffffff",   //background color
        CustomLabelColor: "#51443e",   //labels color
        CustomWidgetColor: "#51443e",   //popovers text color
        CustomButtonColor: "#ffffff",
        CustomButtonBGColor: '#c72b39',
        CustomButtonHoverBGColor: '#c72b39'
      },
    });
  }
});*/

$(document).click(function (event) {
    var clickover = $(event.target);
    var _opened = $(".bottom-overlay-collapsible").hasClass("show");
    if (_opened === true && clickover.parents('#sb-container').length < 1) {
        $(".bottom-overlay-collapsible").collapse('hide');
    }
});
// END SIMPLE BOOKING


// GIFT CARD PRODUCT PAGE
$(document).ready(function () {
    if ($('body').hasClass('single-product')) {
        $('.ywgc-default-product-image').parent().hide();
        $('.ywgc-preset-image:not(.ywgc-default-product-image)').first().find('img').click();
    }
})
// END GIFT CARD PRODUCT PAGE

if ($('body').hasClass('page-template-template-preventivo')) {

    let selectedIsDone = false;
    jQuery(document).on('nfFormReady', function () {

        var searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('selected') && !selectedIsDone) {

            var selectedOfferEnc = htmlEncode(searchParams.get('selected'));
            var selectedOffer = decodeURI(selectedOfferEnc).toLowerCase();

            $('.offers-checkbox-container input').each(function () {
                var $this = $(this);
                if (htmlEncode($this.val()).toLowerCase() === selectedOffer) {
                    $this.parent().find('label').click();
                    selectedIsDone = true;
                }
            });

        }

    });
}

function htmlEncode(str) {
    return String(str).replace(/[^\w. ]/gi, function (c) {
        return '&#' + c.charCodeAt(0) + ';';
    });
}

